module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactList"
  }, [(_vm.isEmpty) ? _c('div', {
    staticClass: "open-people-list"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.openPeopleTab
    }
  }, [_vm._v(_vm._s(_vm.$t("str.SelectContactInTheSession")))])]) : _c('ul', {
    staticClass: "contacts"
  }, _vm._l((_vm.otherContacts), function(contact, index) {
    return _c('chatlistitem', {
      key: index,
      attrs: {
        "user": _vm.user,
        "contact": contact,
        "isSelected": _vm.person && contact.to[0] === _vm.person.id
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c4fdaac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatContacts.vue
// module id = 472
// module chunks = 0